import { useRouteContext } from "@tanstack/react-router";
import { cn } from "@beweegbaas/ui";

/**
 * Small fixed banner (ported from portal's root badge) that shows which isolated IntegreSQL clone a
 * page is running against, so testers can see the leased database at a glance. Rendered only when a
 * test database is set (env or `X-Test-Database` cookie, resolved server-side in `getRouteContext`);
 * absent during normal browsing, so it never appears in production.
 */
export function IntegreSqlBadge() {
  const integreSqlDatabase = useRouteContext({
    from: "__root__",
    select: (ctx) => ctx.integreSqlDatabase,
  });

  if (!integreSqlDatabase) return null;

  return (
    <div
      role="status"
      data-testid="integresql-badge"
      className={cn(
        "sticky top-0 z-[35] border-b border-violet-400/25",
        "bg-violet-950/95 px-3 py-1.5 text-center text-[11px] leading-snug text-violet-100 backdrop-blur-sm",
      )}
    >
      <span className="font-semibold tracking-wide uppercase">IntegreSQL</span>
      <span className="mx-1.5 text-violet-300/90" aria-hidden>
        ·
      </span>
      <span
        data-testid="integresql-badge-name"
        className="inline-block max-w-[min(28rem,calc(100vw-14rem))] truncate align-middle font-mono text-violet-50"
        title={integreSqlDatabase}
      >
        {integreSqlDatabase}
      </span>
    </div>
  );
}
